/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AlertsResponse } from '../models/AlertsResponse';
import type { NeighborhoodScoreResponse } from '../models/NeighborhoodScoreResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NeighborhoodService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get neighborhood danger score
     * Calculates the danger score for a given latitude/longitude within an optional radius. The score is derived from active (non-expired) neighboring reports and offense-flagged interventions. Returns score, level, report breakdown, offense count, and intervention flags.
     * @returns NeighborhoodScoreResponse Score calculated successfully.
     * @throws ApiError
     */
    public neighborhoodScoringControllerGetScore({
        latitude,
        longitude,
        radiusKm = 5,
    }: {
        /**
         * Latitude
         */
        latitude: number,
        /**
         * Longitude
         */
        longitude: number,
        /**
         * Search radius in km (default 5)
         */
        radiusKm?: number,
    }): CancelablePromise<NeighborhoodScoreResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/neighborhoods/score',
            query: {
                'latitude': latitude,
                'longitude': longitude,
                'radiusKm': radiusKm,
            },
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Get alerts for a location
     * Returns active alerts within a radius of the given location. Alerts are composed of two sources:
     *
     * 1. **Neighboring Reports** — All non-expired reports (`expiresAt > NOW()`) in the area, with user interaction data (likes, photos, ownership).
     * 2. **Active Interventions** — Interventions where the current date is between `createdAt` and `expiresAt` (currently within their active surveillance window), with status and offense information.
     *
     * Both lists are sorted by distance from the queried location.
     * @returns AlertsResponse Alerts returned successfully.
     * @throws ApiError
     */
    public neighborhoodScoringControllerGetAlerts({
        latitude,
        longitude,
        radiusKm = 5,
    }: {
        /**
         * Latitude of the location
         */
        latitude: number,
        /**
         * Longitude of the location
         */
        longitude: number,
        /**
         * Search radius in km (default 5)
         */
        radiusKm?: number,
    }): CancelablePromise<AlertsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/neighborhoods/alerts',
            query: {
                'latitude': latitude,
                'longitude': longitude,
                'radiusKm': radiusKm,
            },
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
            },
        });
    }
}
